<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool">
      <template slot="text">电子围栏列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action"
        ><Button size="small" @click="openBlind(row)"> 绑定 </Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      width="1200"
      ref="formModel"
      :title="isAdd ? '新增电子围栏' : '编辑电子围栏'"
      fullscreen
    >
      <div
        style="width: 100%; height: calc(100% - 100px); margin-bottom: 10px"
        slot="topcontent"
      >
        <duobianxing ref="duobianxing"></duobianxing>
      </div>
      <Button type="text" slot="zhouqi" @click="openZhouqi">点击设置</Button>
      <Button slot="btn" type="primary" @click="addUpdate">确认修改</Button>
    </form-model>
    <blind ref="blind" v-model="deviceList" @blind="blind"></blind>
    <Modal
      v-model="zhouqiModel"
      title="触发周期设置"
      :mask-closable="false"
      footer-hide
      width="600"
      height="400"
    >
      <zhouqi ref="zhouqi" @zhouqi="reZhouwi"></zhouqi>
    </Modal>
  </div>
</template>
<script>
import duobianxing from "../map/duobianxing.vue";
import zhouqi from "./zhouqi.vue";
export default {
  components: { duobianxing, zhouqi },
  data() {
    return {
      openForm: false,
      zhouqiModel: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },

        {
          title: "创建者账号",
          key: "createAccount",
          sort: 20,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 21,
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 22,
        },
      ],
      forms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
          span: 6,
        },
        {
          title: "容许时长",
          key: "duration",
          key2: "duration2",
          required: true,

          type: "Select",
          selectType: "obj",
          selectItems: this.$t("times1"),
          span: 6,
        },
        {
          title: "围栏类型",
          key: "type",
          key2: "fenceType2",
          type: "Select1",
          st: "fenceType",
          span: 6,
          required: true,
        },
        {
          title: "周期设置",
          slotForm: "zhouqi",
          span: 6,
          noTable: true,
        },
      ],
      item: {
        coordList: [],
        cs: 2, //	坐标系（1-WGS84，2-GCJ-02，3-BD-09）
        enabled: true,
        name: "",
        type: "1", //类型（1-禁出，2-禁入）
        duration: 60,
        remark: "",
        timeList: [],
        weekList: [],
      },
      tableData: [],

      searchItem: { pageNumber: 1, pageSize: 50 },

      total: 0,
      deviceList: [],
    };
  },
  methods: {
    reZhouwi(v) {
      this.formItem = v;
      this.item.timeList = v.times;
      this.item.weekList = v.days;
      this.zhouqiModel = false;
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/fence/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        for (let i = 0; i < data.length; i++) {
          data[i].duration2 = data[i].duration / 60 + "分钟";
          data[i].type = String(data[i].type);
          data[i].fenceType2 = this.$t("fenceType." + data[i].type);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var ccc = this.$refs.duobianxing.getPoints();
      this.item.coordList = ccc;

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.rule + "/fence/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.rule + "/fence/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.rule + "/fence/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      console.log(row);
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
      this.getItem(row, 1);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/fence/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (type == 1) {
            var data = res.data.data.coordList;
            this.$refs.duobianxing.reData(data);
          } else {
            var d = res.data.data.deviceList;
            console.log(d);
            this.deviceList = [];
            for (let i = 0; i < d.length; i++) {
              var obj = {
                id: d[i].deviceId,
                name: d[i].bindAttr,
                key: d[i].deviceId,
                useType: d[i].useType,
              };
              this.deviceList.push(obj);
            }
            console.log(this.d);
            this.$refs.blind.open(row);
          }
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },

    openBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (const i in data) {
        deviceIdList.push(data[i].id);
      }
      this.axios({
        method: "post",
        url: this.axios.rule + "/fence/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    openZhouqi() {
      this.zhouqiModel = true;
      var ddd = {
        days: this.item.weekList,
        times: this.item.timeList,
      };
      this.$refs.zhouqi.reData(ddd);
    },
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns);
    this.getList();
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  width: 240px;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/rule/ruleFence.vue